import React, { useState } from 'react';
import { Phone, Mail, MessageCircle, MapPin, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from '../hooks/use-toast';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock form submission
    toast({
      title: "Message Sent!",
      description: "We'll get back to you within 24 hours.",
    });
    setFormData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="contact-section">
      <div className="section-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h2 className="section-title">Contact Information</h2>

            {/* Wrap the two groups into a single grid container */}
            <div className="info-columns">
              <div className="info-column">
                <div className="info-block">
                  <h3 className="info-heading">24/7 Rider Support</h3>
                  <div className="info-item">
                    <Phone size={20} className="info-icon" />
                    <span>1-800-ZOPLOP-1 (1-800-967-5671)</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>support@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <MessageCircle size={20} className="info-icon" />
                    <span>Real-time chat support</span>
                  </div>
                </div>
                <div className="info-block">
                  <h3 className="info-heading">Safety & Emergency</h3>
                  <div className="info-item">
                    <Phone size={20} className="info-icon" />
                    <span>1-800-SAFE-NOW (1-800-723-3669)</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>safety@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <MessageCircle size={20} className="info-icon" />
                    <span>One-touch emergency button</span>
                  </div>
                </div>
                <div className="info-block">
                  <h3 className="info-heading">Driver Support</h3>
                  <div className="info-item">
                    <Phone size={20} className="info-icon" />
                    <span>1-800-DRIVERS</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>driversupport@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <MessageCircle size={20} className="info-icon" />
                    <span>Priority support channel</span>
                  </div>
                </div>
                {/* <div className="info-block">
                  <h3 className="info-heading">Corporate Headquarters</h3>
                  <div className="info-item">
                    <MapPin size={20} className="info-icon" />
                    <span>Zoplop Inc.
                      123 Community Drive, Suite 400
                      Toronto, ON M5H 2N2
                      Canada
                    </span>
                  </div>
                </div> */}
              </div>

              <div className="info-column">
               <div className="info-block">
                  <h3 className="info-heading">Corporate Headquarters</h3>
                  <div className="info-item">
                    <MapPin size={20} className="info-icon" />
                    <span>Zoplop Inc.
                      123 Community Drive, Suite 400
                      Toronto, ON M5H 2N2
                      Canada
                    </span>
                  </div>
                </div>
                 <div className="info-block">
                  <h3 className="info-heading">Office Hours</h3>
                  <div className="info-item">
                    <Clock size={20} className="info-icon" />
                    <span>Monday - Friday: 9AM - 6PM EST</span>
                  </div>
                </div>
                <div className="info-block">
                  <h3 className="info-heading">Business Inquiries</h3>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>Corporate Solutions: business@zoplop.ca | 416-555-BUSI</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>Community Organizations: community@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>Partnerships: partnerships@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>Media & Press: media@zoplop.ca</span>
                  </div>
                  <div className="info-item">
                    <Mail size={20} className="info-icon" />
                    <span>Careers: careers@zoplop.ca</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h2 className="section-title mx-4">Contact & Support</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  {/* <label htmlFor="firstName">First Name</label> */}
                  <Input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

              </div>
              <div className="form-group">
                {/* <label htmlFor="lastName">Last Name</label> */}
                <Input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                {/* <label htmlFor="phone">Phone</label> */}
                <Input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                {/* <label htmlFor="email">Email Address</label> */}
                <Input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                {/* <label htmlFor="message">Message</label> */}
                <Textarea
                  id="message"
                  name="message"
                  placeholder="Write Your Message Here..."
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <Button type="submit" className="submit-btn">
                Submit
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;